export const PROTOCOL_HTTP = "http"
export const HOST_API = "https://api.tiendahoreca.co/"
export const PATH_S3_BUCKET = "https://dyl2chk5d7v6b.cloudfront.net"
export const DEFAULT_AVATAR_IMAGE = '../../../public/avatar.png';
export const HOST_API_FROM_FEATHER = "https://api.tiendahoreca.co"

export const BUCKET = 'tiendahoreca-web';